import React from 'react';

export interface SectionBarProps {
  activeSection: string;
  setActiveSection: (text: string) => void;
}

export const SectionBar: React.FC<SectionBarProps> = ({
  activeSection,
  setActiveSection,
}) => {
  const props = {
    activeSection,
    setActiveSection,
  };

  return (
    <div className="section-bar-container">
      <SectionButton {...props} name="Mat & Drikke" slug="mat-og-drikke" />
      <SectionButton {...props} name="Film & Serier" slug="film-og-serier" />
      <SectionButton {...props} name="Byliv & Guider" slug="byliv-og-guider" />
    </div>
  );
};

interface SectionButtonProps extends SectionBarProps {
  name: string;
  slug: string;
}

const SectionButton: React.FC<SectionButtonProps> = ({
  activeSection,
  setActiveSection,
  name,
  slug,
}) => (
  <button
    className={`section-bar-button ${slug} ${
      activeSection === slug ? 'active' : 'inactive'
    }`}
    onClick={() => setActiveSection(slug)}
  >
    {name}
  </button>
);
